import { createRouter, createWebHistory } from "vue-router";
import Default from "../views/pages/dashboards/Default.vue";
import Strain from "../views/pages/overview/Strain.vue";
import Recovery from "../views/pages/overview/Recovery.vue";
import Sleep from "../views/pages/overview/Sleep.vue";
import Users from "../views/pages/overview/Users.vue";
import AiProfiler from "../views/pages/overview/AiProfiler.vue";
import TopProfiles from "../views/pages/overview/TopProfiles.vue";
import UserPhysiologicalData from "../views/pages/overview/UserPhysiologicalData.vue";
import UserAccounts from "../views/pages/manage/users/UserAccounts.vue";
import KnowledgeBase from "../views/pages/help/KnowledgeBase.vue";
import Basic from "../views/auth/signin/Basic.vue";
import Error404 from "../views/auth/error/Error404.vue";
import Error500 from "../views/auth/error/Error500.vue";
// import DashBoardV2 from "../views/pages/dashboards/v2/DashBoardV2.vue";
// import DashboardVideoBg from "../views/pages/dashboards/v2/DashboardVideoBg.vue";
import LiveChallengeBoard from "../views/pages/dashboards/challenge/LiveChallengeBoard.vue";
import ChallengeManagement  from "../views/pages/dashboards/challenge/ChallengeManagement.vue";
import Constants from "@/helpers/constants";
import LeaderBoard from "../views/pages/leaderboard/LeaderBoard.vue";
import UserBedWakeChart from "../views/pages/overview/components/UserBedWakeChart.vue";
import UserOptimalStrainChart from "../views/pages/overview/components/insights/UserOptimalStrainChart.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/login",
  },
  {
    path: "/bed-wake-chart",
    name: "UserBedWakeChart",
    component: UserBedWakeChart,
  },
  {
    path: "/login",
    name: "Login",
    component: Basic,
  },
  {
    path: "/users/:udid",
    name: "User",
    component: UserPhysiologicalData,
    props: true,
    query:{
      date: String,
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dashboards/home",
    name: "Home",
    component: Default,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/overview/strain",
    name: "Strain",
    component: Strain,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/overview/recovery",
    name: "Recovery",
    component: Recovery,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/overview/sleep",
    name: "Sleep",
    component: Sleep,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/overview/users",
    name: "Users",
    component: Users,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/overview/ai_profiler",
    name: "Recommended Profiles",
    component: AiProfiler,
    query:{
      profile: String,
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/overview/top_profiles",
    name: "Top Profiles",
    component: TopProfiles,
    query:{
      profile: String,
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/help/knowledgebase",
    name: "Knowledge Base",
    component: KnowledgeBase,
    query:{
      section: String,
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage/users",
    name: "User Accounts",
    component: UserAccounts,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/error500",
    name: "Error Error500",
    component: Error500,
  },
  {
    path: "/live-challenge",
    name: "LiveChallengeDashBoard",
    component: LiveChallengeBoard,
    props: true,
    query:{
      challengeId: String,
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage/challenges",
    name: "ChallengeBoard",
    component: ChallengeManagement,
  },
  {
    path: "/overview/leaderboard",
    name: "Leaderboard",
    components: {
      default: LeaderBoard
    },
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/v2/dashboard",
  //   name: "New Dash Board",
  //   component: DashBoardV2,
  // },
  // {
  //   path: "/v2/dashboard-vd-bg",
  //   name: "Dash Board Video Bg",
  //   component: DashboardVideoBg,
  // },
  // {
  //   path: "/realtime-notifications",
  //   name: "RealTimeNotifications",
  //   component: RealTimeNotifications,
  // },
  // {
  //   path: "/publish-alert",
  //   name: "PublishAlert",
  //   component: PublishRealTimeAlert,
  // },
  {
    path: "/os-chart",
    name: "UserOptimalStrainChart",
    component: UserOptimalStrainChart,
  },
  { path: "/:pathMatch(.*)*", name: "Error404", component: Error404 },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});

// Route guards before navigation
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Check if user is authenticated and allowed to access the route
    let me = null;
    try {
      me = JSON.parse(localStorage.getItem("me"));
    } catch (e) {
      me = null;
    }
    if (me && me.is_auth) {
      if(me.role && me.role.role_id == Constants.ROLES.USER_MANAGER && to.name != "User Accounts") {
        return next("/login");
      }
      return next();
    } else {
      return next("/login");
    }
  } else next(); // Public routes
});

export default router;
